<section class="flex-col title__section">
  <h2 class="heading-4">Enter your Product Number Code and ML code</h2>
  <div>
    <p class="body">
      You'll find these on a sticker or rating plate on your appliance. We use them to identify your exact model so we
      can bring the right parts.
    </p>
  </div>
</section>

@if (vm.fields['PNCNumber']) {
  <section class="flex-col gap-8">
    <app-text-search
      textInputClasses="max-w-332"
      [name]="vm.fields['PNCNumber'].fieldIdentifier"
      label="Product Number Code (PNC)"
      placeHolder="Enter 3 numbers to search"
      selectedLabel="Your PNC"
      searchIconPosition="start"
      [ngModel]="vm.formValue?.[vm.fields['PNCNumber'].fieldIdentifier]"
      [useOrbitSearch]="vm.fields['PNCNumber']"
      [errors]="
        vm.formSubmitted && !vm.formValue?.[vm.fields['PNCNumber'].fieldIdentifier]
          ? (vm.errors['section'] | stringify: true)
          : undefined
      "
      [hideNoResultsHint]="true"
      (loadingData)="onPncLoadingData()"
      (loadingError)="onPncSearchError()"
      (noResults)="onPncNoResults()"
    >
    </app-text-search>
    @if (vm.pncSearchError || vm.pncNoResults) {
      <section
        class="search-state-info flex-col gap-4 max-w-332"
        [attr.data-testid]="vm.pncSearchError ? 'pnc-search-error' : 'pnc-no-results'"
      >
        @if (vm.pncSearchError) {
          <section class="title flex gap-8">
            <i class="fa-light fa-triangle-exclamation"></i>
            <p class="label">Search is temporarily unavailable</p>
          </section>
          <p class="body">We're having trouble connecting to our system. Please come back later and try again.</p>
        } @else {
          <section class="title flex gap-8">
            <i class="fa-light fa-circle-exclamation"></i>
            <p class="label">No results found</p>
          </section>
          <p class="body">Double-check the number on your product, try again, and select from the list.</p>
        }
      </section>
    }
    @if (
      vm.errors['section']?.['required'] && vm.formSubmitted && !vm.formValue?.[vm.fields['PNCNumber'].fieldIdentifier]
    ) {
      <section class="error flex gap-8">
        <i class="fa-light fa-circle-exclamation"></i>
        <p class="body" data-testid="pnc-number-empty-error">PNC is required</p>
      </section>
    }
  </section>
}

@if (vm.fields['MLCode']) {
  <section class="flex-col gap-8">
    <app-text-input
      class="max-w-332"
      [name]="vm.fields['MLCode'].fieldIdentifier"
      label="ML code"
      placeHolder="Enter 2 digits"
      [maxlength]="2"
      [ngModel]="vm.formValue?.[vm.fields['MLCode'].fieldIdentifier]"
      dataTestId="ml-code-input"
      [error]="
        vm.errors['section']?.['required'] && vm.formSubmitted && !vm.formValue?.[vm.fields['MLCode'].fieldIdentifier]
          ? 'required'
          : vm.errors['section']?.['mlCodeInvalid'] && vm.formSubmitted
            ? 'invalid'
            : undefined
      "
    ></app-text-input>
    @if (
      vm.errors['section']?.['required'] && vm.formSubmitted && !vm.formValue?.[vm.fields['MLCode'].fieldIdentifier]
    ) {
      <section class="error flex gap-8">
        <i class="fa-light fa-circle-exclamation"></i>
        <p class="body" data-testid="ml-code-empty-error">ML code is required</p>
      </section>
    }
    @if (
      vm.errors['section']?.['mlCodeInvalid'] && vm.formSubmitted && vm.formValue?.[vm.fields['MLCode'].fieldIdentifier]
    ) {
      <section class="error flex gap-8">
        <i class="fa-light fa-circle-exclamation"></i>
        <p class="body" data-testid="ml-code-invalid-error">ML code is invalid</p>
      </section>
    }
  </section>
}

<section class="panel" [class.open]="vm.panelExpanded">
  <section class="header">
    <button
      type="button"
      class="label flex gap-8 body large"
      (click)="panelExpanded.set(!vm.panelExpanded)"
      data-testid="where-to-find-codes"
    >
      <span>Where can I find these codes?</span>
      <i class="fa-regular" [class.fa-chevron-up]="vm.panelExpanded" [class.fa-chevron-down]="!vm.panelExpanded"></i>
    </button>
  </section>

  <section [appAnimateOpen]="vm.panelExpanded" class="content">
    <section class="flex-col gap-16 mt-8">
      @if (vm.brandImage) {
        <img
          [src]="'assets/images/model-number-diagrams/' + vm.brandImage"
          alt="Appliance rating plate showing location of codes"
        />
      }

      <ol class="code-list flex-col gap-8">
        <li class="body">Model number</li>
        <li class="body">Product number</li>
        <li class="body">ML code</li>
        <li class="body">Serial number</li>
      </ol>

      <p class="body">
        The ML code helps us identify your exact appliance. If you can’t find it, enter 97. We can still identify your
        model using your PNC.
      </p>

      <section class="panel" [class.open]="vm.callPanelExpanded">
        <section class="header">
          <button
            type="button"
            class="label flex gap-8 body large"
            (click)="toggleCallPanel()"
            data-testid="still-cant-find-codes"
          >
            <span>Still can't find these codes?</span>
            <i
              class="fa-regular"
              [class.fa-chevron-up]="vm.callPanelExpanded"
              [class.fa-chevron-down]="!vm.callPanelExpanded"
            ></i>
          </button>
        </section>

        @if (vm.callPanelExpanded) {
          <section class="call-us flex-col gap-8 mt-8">
            <p class="label">Give us a call</p>
            <app-telephone-link phoneNumber="0333 000 9703" />
            <p class="hint">
              Calls cost the basic rate per minute plus your phone company's access charge. From a mobile, they can cost
              much more. Calls to 0800 numbers are always free.
            </p>
          </section>
        }
      </section>
    </section>
  </section>

  <div class="divider"></div>
</section>
